// This will be a new, separate component for the modal form.
// Creating it in a new file: nexui_frontend/src/components/templates/TemplateFormModal.jsx

import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

export default function TemplateFormModal({ isOpen, onClose, onSave, templateData }) {
  const [formData, setFormData] = useState({});

  useEffect(() => {
    // If templateData is provided, it's an edit, otherwise it's a new template
    setFormData(templateData || {
      name: '',
      description: '',
      content: '',
      titleTemplate: '',
      suggestedTone: '',
      emojiStyle: '',
      sceneTags: '',
      visualStyle: '',
      status: 'ACTIVE',
      type: 'STRUCTURE'
    });
  }, [templateData, isOpen]);

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center p-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[90vh] flex flex-col">
        <div className="flex justify-between items-center p-5 border-b border-gray-200">
          <h2 className="text-lg font-semibold text-gray-800">
            {templateData ? '编辑结构模板' : '新建结构模板'}
          </h2>
          <button onClick={onClose} className="p-1 rounded-full hover:bg-gray-100">
            <X className="w-5 h-5 text-gray-500" />
          </button>
        </div>
        
        <form onSubmit={handleSubmit} className="overflow-y-auto flex-grow">
          <div className="p-6 space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">模板名称 *</label>
              <input type="text" name="name" value={formData.name} onChange={handleChange} required className="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-indigo-500 focus:border-indigo-500" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">模板描述</label>
              <textarea name="description" value={formData.description} onChange={handleChange} rows="2" className="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-indigo-500 focus:border-indigo-500"></textarea>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">内容框架 (模板核心) *</label>
              <textarea name="content" value={formData.content} onChange={handleChange} required rows="5" placeholder='例如：&#10;1. 痛点引入&#10;2. 产品介绍&#10;3. 使用体验&#10;4. 效果展示&#10;5. 总结推荐' className="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-indigo-500 focus:border-indigo-500"></textarea>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">标题模板句式</label>
                <input type="text" name="titleTemplate" value={formData.titleTemplate} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-indigo-500 focus:border-indigo-500" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">适用场景 (逗号分隔)</label>
                <input type="text" name="sceneTags" value={formData.sceneTags} onChange={handleChange} placeholder="例如: 小红书,种草,测评" className="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-indigo-500 focus:border-indigo-500" />
              </div>
            </div>
             <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">🎨 视觉风格/美术指导 (可选)</label>
              <textarea
                name="visualStyle"
                value={formData.visualStyle || ''}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-indigo-500 focus:border-indigo-500"
                placeholder="例如: 画面媒介：极简实拍 | 色彩基调：冷色调 | 氛围光影：清晨柔光 | 核心元素：产品特写"
                rows="2"
              />
             </div>

             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">建议语气风格</label>
                <input type="text" name="suggestedTone" value={formData.suggestedTone} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-indigo-500 focus:border-indigo-500" />
              </div>
               <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">推荐emoji风格</label>
                <input type="text" name="emojiStyle" value={formData.emojiStyle} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-indigo-500 focus:border-indigo-500" />
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">状态</label>
              <select name="status" value={formData.status} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-indigo-500 focus:border-indigo-500">
                <option value="ACTIVE">启用</option>
                <option value="INACTIVE">停用</option>
              </select>
            </div>
          </div>
          
          <div className="bg-gray-50 px-6 py-4 border-t border-gray-200 flex justify-end gap-3">
            <button type="button" onClick={onClose} className="px-4 py-2 bg-white border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50">
              取消
            </button>
            <button type="submit" className="px-4 py-2 bg-indigo-600 border border-transparent rounded-lg text-sm font-medium text-white hover:bg-indigo-700">
              保存模板
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
